import { connect } from 'react-redux';
import { SearchBox } from '../components';

export default connect(null, null)(SearchBox);